'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _index = require('../../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _consts = require('photography-client-lib/dist/src/utils/consts');

var _consts2 = _interopRequireDefault(_consts);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _designConsts = require('../../../constants/designConsts.js');

var _designConsts2 = _interopRequireDefault(_designConsts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minWidthToShowContent = 135;
var minWithForNormalSizedItem = 190;

var LineHeightFixer = function () {
  function LineHeightFixer() {
    (0, _classCallCheck3.default)(this, LineHeightFixer);
  }

  (0, _createClass3.default)(LineHeightFixer, [{
    key: 'getDimensions',
    value: function getDimensions(element) {
      var cs = _windowWrapper2.default.getComputedStyle(element);
      var paddingY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
      var paddingX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);

      var borderX = parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth);
      var borderY = parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

      return {
        width: element.clientWidth - paddingX - borderX,
        height: element.clientHeight - paddingY - borderY
      };
    }
  }, {
    key: 'saveCurrentDisplay',
    value: function saveCurrentDisplay(element) {
      element && element.setAttribute('data-display', this.getCss(element, 'display'));
    }
  }, {
    key: 'getSavedDisplay',
    value: function getSavedDisplay(element) {
      return element && element.getAttribute('data-display') || '-webkit-box';
    }
  }, {
    key: 'removeElement',
    value: function removeElement(element) {
      this.saveCurrentDisplay(element);
      this.setCss(element, { display: 'none' });
    }
  }, {
    key: 'hideElement',
    value: function hideElement(element) {
      var shouldOverrideDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (shouldOverrideDisplay) {
        var display = this.getSavedDisplay(element);
        this.setCss(element, { visibility: 'hidden', display: display });
      } else {
        this.setCss(element, { visibility: 'hidden' });
      }
    }
  }, {
    key: 'showElement',
    value: function showElement(element) {
      var shouldOverrideDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (shouldOverrideDisplay) {
        var display = this.getSavedDisplay(element);
        this.setCss(element, { visibility: 'visible', display: display });
      } else {
        this.setCss(element, { visibility: 'visible' });
      }
    }
  }, {
    key: 'getCss',
    value: function getCss(element, rule) {
      return _windowWrapper2.default.getComputedStyle(element)[rule];
    }
  }, {
    key: 'setCss',
    value: function setCss(element, styles) {
      try {
        (0, _assign2.default)(element.style, styles);
      } catch (e) {
        //
      }
    }
  }, {
    key: 'shouldFix',
    value: function shouldFix(oldOptions, newOptions) {
      var styleParams = oldOptions.styleParams,
          title = oldOptions.title,
          description = oldOptions.description,
          isSmallItem = oldOptions.isSmallItem,
          style = oldOptions.style;

      var newStyleParams = newOptions.styleParams;
      var newTitle = newOptions.title;
      var newDescription = newOptions.description;
      var newIsSmallItems = newOptions.isSmallItem;
      var newStyle = newOptions.style;
      var newIsSocialPopulated = newStyleParams.allowSocial || newStyleParams.loveButton || newStyleParams.allowDownload;
      var oldIsSocialPopulated = styleParams.allowSocial || styleParams.loveButton || styleParams.allowDownload;
      return style.height !== newStyle.height || style.width !== newStyle.width || styleParams.isSlideshow !== newStyleParams.isSlideshow || styleParams.allowTitle !== newStyleParams.allowTitle || styleParams.allowDescription !== newStyleParams.allowDescription || styleParams.slideshowInfoSize !== newStyleParams.slideshowInfoSize || styleParams.externalInfoHeight !== newStyleParams.externalInfoHeight || oldIsSocialPopulated !== newIsSocialPopulated || title !== newTitle || description !== newDescription || isSmallItem !== newIsSmallItems;
    }
  }, {
    key: 'calcAvailableHeight',
    value: function calcAvailableHeight(options, textPlacementAboveOrBelow, textsContainerHeight) {
      var styleParams = options.styleParams,
          itemContainer = options.itemContainer;

      var availableHeight = void 0;

      if (styleParams.isSlideshow) {
        var socialElements = itemContainer.getElementsByClassName('gallery-item-social');
        var socialElement = socialElements.length > 0 && socialElements[0];
        var socialHeight = socialElement.clientHeight;
        var socialMarginBottom = parseInt(this.getCss(socialElement, 'margin-bottom'));
        var itemInfoChildDivPaddingTop = 24; //padding-top of the div inside gallery-item-info
        availableHeight = styleParams.slideshowInfoSize - itemInfoChildDivPaddingTop - socialHeight - socialMarginBottom;
      } else if (textPlacementAboveOrBelow) {
        var className = styleParams.titlePlacement === _consts2.default.placements.SHOW_BELOW ? 'gallery-item-bottom-info' : 'gallery-item-top-info';
        var elements = itemContainer.getElementsByClassName(className);
        var element = elements.length > 0 && elements[0];
        var elementPadding = parseInt(this.getCss(element, 'padding-top')) + parseInt(this.getCss(element, 'padding-bottom'));
        availableHeight = styleParams.externalInfoHeight - elementPadding;
      } else {
        availableHeight = textsContainerHeight;
      }

      return availableHeight;
    }
  }, {
    key: 'fix',
    value: function fix(options, container) {
      if (_index2.default.isTest()) {
        return;
      }

      var styleParams = options.styleParams,
          title = options.title,
          description = options.description,
          isSmallItem = options.isSmallItem;


      var textPlacementAboveOrBelow = false;
      if (styleParams.titlePlacement === _consts2.default.placements.SHOW_BELOW || styleParams.titlePlacement === _consts2.default.placements.SHOW_ABOVE) {
        textPlacementAboveOrBelow = true;
      }

      if (!container || !(options && options.itemContainer)) {
        return;
      }

      var dimensions = this.getDimensions(container);
      var availableHeight = this.calcAvailableHeight(options, textPlacementAboveOrBelow, dimensions.height);

      var customButtonElements = container.getElementsByClassName('custom-button-wrapper');
      var titleElements = container.getElementsByClassName('gallery-item-title');
      var descriptionElements = container.getElementsByClassName('gallery-item-description');
      var customButtonExists = customButtonElements.length > 0;

      var customButtonElement = customButtonExists && customButtonElements[0];
      var titleElement = titleElements.length > 0 && titleElements[0];
      var descriptionElement = descriptionElements.length > 0 && descriptionElements[0];

      var isItemWidthToSmall = dimensions.width < minWidthToShowContent;

      this.hideElement(titleElement);
      this.hideElement(descriptionElement, !textPlacementAboveOrBelow); //if textPlacementAboveOrBelow, descriptionElement should not get 'display: -webkit-box'
      this.hideElement(customButtonElement, !(styleParams.isSlideshow || textPlacementAboveOrBelow)); //if Slideshow or if textPlacementAboveOrBelow, customButtonElement should not get 'display: -webkit-box'

      if (customButtonExists) {
        this.showElement(customButtonElement, !(styleParams.isSlideshow || textPlacementAboveOrBelow)); //if Slideshow or if textPlacementAboveOrBelow, customButtonElement should not get 'display: -webkit-box'
        var buttonHeight = this.getDimensions(customButtonElement).height;
        if (availableHeight + 30 < buttonHeight) {
          this.removeElement(customButtonElement);
          customButtonExists = false;
        } else if (isItemWidthToSmall) {
          this.setCss(customButtonElement.querySelector('button'), { 'min-width': 0 + 'px', 'max-width': minWidthToShowContent + 'px' });
        } else if (dimensions.width < minWithForNormalSizedItem) {
          this.setCss(customButtonElement.querySelector('button'), { 'min-width': minWidthToShowContent + 'px', 'max-width': dimensions.width + 'px' });
        }

        var isButtonHeightAvailable = !_lodash2.default.isNaN(buttonHeight);
        if (isButtonHeightAvailable && customButtonExists) {
          availableHeight -= buttonHeight;
          availableHeight -= _designConsts2.default.spaceBetweenElements;
          if (availableHeight < 0) {
            availableHeight = 0;
          }
        }
      }

      var shouldDisplayTitle = title && !isSmallItem && styleParams.allowTitle;
      if (shouldDisplayTitle) {
        this.showElement(titleElement);
        this.setCss(titleElement, { overflow: 'visible' });
        if (titleElements.length === 1) {
          var titleHeight = parseInt(titleElement.clientHeight);
          var titleLineHeight = parseInt(this.getCss(titleElement, 'line-height'));
          var numOfTitleLines = 1;
          if (titleHeight >= titleLineHeight) {
            numOfTitleLines = Math.floor(titleHeight / titleLineHeight);
          }
          var numOfAvailableLines = Math.floor(availableHeight / titleLineHeight);

          if (numOfAvailableLines === 0) {
            this.removeElement(titleElement);
          } else {
            this.setCss(titleElement, { overflow: 'hidden' });

            var isTitleFitInAvailableHeight = numOfAvailableLines <= numOfTitleLines;
            if (isTitleFitInAvailableHeight) {
              this.setCss(titleElement, { '-webkit-line-clamp': numOfAvailableLines + '' });
              titleHeight = titleLineHeight * numOfAvailableLines;
            } else {
              this.setCss(titleElement, { '-webkit-line-clamp': 'none' });
              titleHeight = titleLineHeight * numOfTitleLines;
            }

            var isThereAnyAvailableHeightLeft = availableHeight > titleHeight;
            if (isThereAnyAvailableHeightLeft) {
              availableHeight -= titleHeight;
            } else {
              availableHeight = 0;
            }
          }
        }
      }

      var shouldDisplayDescription = descriptionElement && !isSmallItem && styleParams.allowDescription && description && availableHeight > 0;
      if (shouldDisplayDescription) {
        this.showElement(descriptionElement, !textPlacementAboveOrBelow); //if textPlacementAboveOrBelow, descriptionElement should not get 'display: -webkit-box'
        if (shouldDisplayTitle) {
          availableHeight -= _designConsts2.default.spaceBetweenTitleAndDescription;
        }
        if (availableHeight < 0) {
          availableHeight = 0;
        }
        var lineHeight = parseInt(this.getCss(descriptionElement, 'line-height'));
        var numOfLines = Math.floor(availableHeight / lineHeight);
        if (numOfLines === 0) {
          this.removeElement(descriptionElement);
        } else {
          this.setCss(descriptionElement, { overflow: 'hidden', '-webkit-line-clamp': numOfLines + '' });
        }
      }
    }
  }]);
  return LineHeightFixer;
}();

exports.default = new LineHeightFixer();